import {
    DatasourceColumnId,
    ICompiledSQLTokens,
} from 'src/app/utils/datasource-sql-map/datasource';

/**
 * Helper for building SQL queries for the table dashboard item.
 */
export class TableSqlBuilderHelper {
    /**
     * Creates splitSelect in the form: dsCol.columnSQL AS dsCol.id
     *
     * @param sqlTokens - An array of objects containing the id and compiledTokens.
     *
     * @returns A string representing the splitSelect.
     * For example: "dsCol.columnSQL AS dsCol.id, ...".
     *
     * @throws {Error} If split_group has more than one element.
     */
    static getSplitSelect(
        sqlTokens: {
            id: DatasourceColumnId;
            compiledSqlTokens: Partial<ICompiledSQLTokens>;
        }[],
        /** Whether to return only the column IDs without select statement */
        columnIdOnly: boolean = false,
        sourceAlias?: string
    ) {
        sourceAlias = sourceAlias ? `${sourceAlias}.` : '';
        const splitSelect = sqlTokens
            .filter((sqlToken) => sqlToken.compiledSqlTokens.split_group)
            .map((sqlToken) => {
                // error if split_group has more than one element
                if (sqlToken.compiledSqlTokens.split_group!.length > 1)
                    throw new Error(
                        `split_group has more than one element: ${JSON.stringify(
                            sqlToken
                        )}`
                    );
                const selectColumn = columnIdOnly
                    ? ''
                    : `${sqlToken.compiledSqlTokens.split_group![0]} AS`;
                return `${selectColumn} ${sourceAlias}${sqlToken.id}`;
            })
            .join(', ');

        return splitSelect;
    }

    /** Creates splitGroupBy in the form: dsCol.id */
    static getSplitGroupBy(
        sqlTokens: {
            id: DatasourceColumnId;
            compiledSqlTokens: Partial<ICompiledSQLTokens>;
        }[]
    ) {
        const splitGroupBy = sqlTokens
            .filter((sqlToken) => sqlToken.compiledSqlTokens.split_group)
            .map((sqlToken) => {
                // error if split_group has more than one element
                if (sqlToken.compiledSqlTokens.split_group!.length > 1)
                    throw new Error(
                        `split_group has more than one element: ${JSON.stringify(
                            sqlToken
                        )}`
                    );
                return `${sqlToken.id}`;
            })
            .join(', ');

        return splitGroupBy;
    }
}
